import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import './ConfirmationForm.css';
import { useNavigate, useLocation } from 'react-router-dom';

import CIB from './assets/logo_cib.png';

const PAYMENT_METHODS = [
  {
    id: 'CIB',
    name: 'Paiement CIB/EDAHABIA',
    image: CIB,
    description: 'Paiement sécurisé utilisant CIB ou EDAHABIA'
  },

 
 
];

  
const ConfirmationForm = ({ onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    room,
    checkInDate,
    checkOutDate,
    adults,
    children,
    rooms: initialRooms
  } = location.state || {};

  const [seaView, setSeaView] = useState(false);
  const [rooms, setRooms] = useState(initialRooms || 1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [client, setClient] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
  });

  const [selectedMethod, setSelectedMethod] = useState(PAYMENT_METHODS[0].id);
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: ''
  });

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [reservationId, setReservationId] = useState(null);

  // ✅ Total incluant vue sur mer
  useEffect(() => {
    const nights = Math.ceil(
      (new Date(checkOutDate) - new Date(checkInDate)) / (1000 * 60 * 60 * 24)
    );

    const seaViewPrice =
      seaView && room?.type?.toLowerCase() === 'suite'
        ? 2000
        : seaView
        ? 2500
        : 0;

    const total = (room?.prix_nuit + seaViewPrice) * nights * rooms;
    setTotalAmount(total);
  }, [rooms, room, checkInDate, checkOutDate, seaView]);

  const handleAddRoom = () => {
    setRooms(prev => prev + 1);
  };
const [captchaToken, setCaptchaToken] = useState(null);
const [acceptedConditions, setAcceptedConditions] = useState(false);

const [errors, setErrors] = useState({});
const validateFields = () => {
  const newErrors = {};

  // 🔹 Vérification Nom
  if (!client.nom.trim()) {
    newErrors.nom = 'Le nom est requis';
  } else if (client.nom.trim().length < 3) {
    newErrors.nom = 'Le nom doit contenir au moins 3 lettres';
  }

  // 🔹 Vérification Prénom
  if (!client.prenom.trim()) {
    newErrors.prenom = 'Le prénom est requis';
  } else if (client.prenom.trim().length < 3) {
    newErrors.prenom = 'Le prénom doit contenir au moins 3 lettres';
  }

  // 🔹 Vérification Email
  if (!client.email.trim()) {
    newErrors.email = 'L’email est requis';
  } else if (!/^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(client.email.trim())) {
    newErrors.email = 'L’email doit être une adresse valide se terminant par @gmail.com';
  }

  // 🔹 Vérification Téléphone
  if (!client.telephone.trim()) {
    newErrors.telephone = 'Le numéro de téléphone est requis';
  } else if (!/^0\d{9}$/.test(client.telephone.trim())) {
    newErrors.telephone = 'Le numéro doit commencer par 0 et contenir exactement 10 chiffres';
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

 
const handlePaiement = async () => {
    if (!validateFields()) return;
  if (!captchaToken) {
    alert("Veuillez valider le Captcha.");
    return;
  }

  if (!acceptedConditions) {
    alert("Vous devez accepter les conditions générales avant de payer.");
    return;
  }

  const paiementInfos = {
    id_chambre: room._id,
    date_entree: checkInDate,
    date_sortie: checkOutDate,
    nombre_adultes: adults,
    nombre_enfants: children,
    nombre_chambres: rooms,
    client,
    paymentMethod: selectedMethod,
    paymentDetails,
    totalAmount,
    vue_sur_mer: seaView,
    captchaToken,
  };

  // stocker temporairement la réservation
  localStorage.setItem("reservationData", JSON.stringify(paiementInfos));
  localStorage.setItem('reservationAmount', totalAmount);
  localStorage.setItem('paymentMessage', "Paiement réussi");


  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/paiement/create-session`, {
      id_chambre: room._id,
      montant: totalAmount,
      client,
    });

    if (response.data && response.data.lien) {
      setShowConfirmation(true);
      window.location.href = response.data.lien; // redirection vers SATIM
    } else {
      alert("Erreur lors de la création de la session de paiement.");
    }
  } catch (error) {
    console.error("Erreur lors de la demande de paiement :", error);
    alert("Échec de l'initialisation du paiement.");
  }
};



  return (
    <div className='bodyPageR'>
      <div className="overlay">
        <h1 className="confirmation-title">Confirmation de la réservation</h1>

        <div className="booking-summary">
          <h3>Récapitulatif de la réservation</h3>
          <br />
          <p><strong>Type de chambre:</strong> {room?.type}</p>
          <p><strong>Date d'entrée:</strong> {checkInDate}</p>
          <p><strong>Date de sortie:</strong> {checkOutDate}</p>
          <p><strong>Nombre d'adultes:</strong> {adults}</p>
          <p><strong>Nombre d'enfants:</strong> {children}</p>
          <p><strong>Nombre de chambres:</strong> {rooms}</p>
          <p><strong>Prix par nuit:</strong> {room?.prix_nuit}.00 DA</p>

          <div className="sea-view-option" style={{ margin: '10px 0' }}>
            <label>
              <input
                type="checkbox"
                checked={seaView}
                onChange={() => setSeaView(!seaView)}
              />
              {' '}Vu sur mer {seaView && `( +${room?.type?.toLowerCase() === 'suite' ? 2000 : 2500} DA par nuit )`}
            </label>
          </div>

          <p><strong>Total à payer:</strong> {totalAmount.toFixed(2)} DA</p>
          <button onClick={handleAddRoom}>Ajouter une chambre</button>
        </div>

        < div className="reservation-container" onClick={(e) => e.stopPropagation()}>

          <div className="payment-section">
            <h2 className='payementTitle'>Méthode de paiement</h2>
            <div className="payment-methods">
              {PAYMENT_METHODS.map(method => (
                <div
                  key={method.id}
                  className={`payment-method ${selectedMethod === method.id ? 'active' : ''}`}
                  onClick={() => setSelectedMethod(method.id)}
                >
                  <div className="method-icon">
                    <img src={method.image} alt={method.name} />
                  </div>
                  <div className="method-info">
                    <h3>{method.name}</h3>
                    <p>{method.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="personal-section">
            <h2 className='infoTitle'>Informations personnelles</h2>
            <form>
              <div className="input-group-api">
                <label>
                  Nom<span style={{ color: 'red' }}> *</span>

                </label>
                <input
                  type="text"
                  placeholder="Votre nom"
                  value={client.nom}
                  onChange={(e) => setClient({ ...client, nom: e.target.value })}
                  required
                />
                  {errors.nom && <small className="error-text">{errors.nom}</small>}
              </div>

              <div className="input-group-api">
                <label>
                  Prénom<span style={{ color: 'red' }}> *</span>
                  </label>
                <input
                  type="text"
                  placeholder="Votre prénom"
                  value={client.prenom}
                  onChange={(e) => setClient({ ...client, prenom: e.target.value })}
                  required
                />
                  {errors.prenom && <small className="error-text">{errors.prenom}</small>}
              </div>

              <div className="input-group-api">
                <label>
                  Email<span style={{ color: 'red' }}> *</span>
                  </label>
                <input
                  type="email"
                  placeholder="votreemail@email.com"
                  value={client.email}
                  onChange={(e) => setClient({ ...client, email: e.target.value })}
                  required
                />
                  {errors.email && <small className="error-text">{errors.email}</small>}
              </div>

              <div className="input-group-api">
                <label>
                  Téléphone<span style={{ color: 'red' }}> *</span>
                  </label>
                <input
                  type="tel"
                  placeholder="Ex: 0555123456"
                  value={client.telephone}
                  onChange={(e) => setClient({ ...client, telephone: e.target.value })}
                  required
                />
                  {errors.telephone && <small className="error-text">{errors.telephone}</small>}
              </div>
              <div className="form-actions-pre">
  <div className="input-group-api">
    <label>
      <input
        type="checkbox"
        checked={acceptedConditions}
        onChange={() => setAcceptedConditions(!acceptedConditions)}
        required
      />
      {' '}
      J’ai lu et j’accepte les{' '}
      <a href="/conditions-generales" target="_blank" rel="noopener noreferrer">
        conditions générales de vente et de paiement en ligne
      </a>.
    </label>
  </div>

  <div style={{ margin: '20px 0' }}>
    <ReCAPTCHA
      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      onChange={setCaptchaToken}
    />
  </div>
</div>

<div className="form-actions">
  <button type="button" className="cancel-btn" onClick={() => navigate(-1)}>
    Annuler
  </button>
  <button type="button" className="submit-btn"   onClick={handlePaiement}>
    Payer {totalAmount.toFixed(2)} DA
  </button>
</div>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationForm;
